import _taggedTemplateLiteral from '../node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js';
import styled from 'styled-components';

var _templateObject;
const CodeBlockDiv = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: 0.8em;\n  display: block;\n  border-radius: ", ";\n  border: ", ";\n  background-color: ", ";\n\n  & .CodeBlock__content {\n    border-radius: ", ";\n    position: relative;\n  }\n\n  pre {\n    padding: 14px 18px;\n    margin: 0;\n    border-radius: ", ";\n    overflow: scroll;\n  }\n\n  // Copy icon\n  .CodeBlock__copyBtn {\n    color: ", " !important;\n  }\n  .CodeBlock__copyBtn:hover {\n    color: ", " !important;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.codeBlockBorderRadius;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.codeBlockBorder;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.codeBlockBackground;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.codeBlockBorderRadius;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.codeBlockBorderRadius;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colorCopyCodeIcon;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colorCopyCodeIconHover;
});

export { CodeBlockDiv };
